export enum SettingsExpressionsDataEventObjectsEnum {
  CREATE_EXPRESSION = 'create_expression',
  EDIT_EXPRESSION = 'edit_expression',
}
